//
//
//
//
//
//
//
//
//
export default {
  name: "ImageReader",
  props: {
    image: {
      requried: true
    }
  },
  data: function data() {
    return {
      imageSource: null
    };
  },
  methods: {
    readImage: function readImage() {
      var $this = this;

      if (this.image instanceof Blob) {
        var fileReader = new FileReader();
        fileReader.readAsDataURL(this.image);

        fileReader.onload = function () {
          $this.imageSource = this.result;
        };
      } else {
        this.imageSource = this.image.url || "";
      }
    }
  },
  mounted: function mounted() {
    this.readImage();
  },
  watch: {
    image: function image() {
      this.readImage();
    }
  },
  updated: function updated() {
    this.readImage();
  }
};